import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import "./../../Shared/Home.css";
import "./../../Shared/Table.css";
import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../../Shared/Navbar";
import * as XLSX from "xlsx";
import { baseUrl } from "./../../Apiurls/Apiurls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTrash, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "./../../Contextapi/ContextApi";

const ViewApplication = () => {
  const navigate = useNavigate();
  const { userId, userRole, logout } = useContext(AuthContext);
  const [usedButtons, setUsedButtons] = useState(new Set());
  const [activeFilter, setActiveFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [formDataList, setFormDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importStatus, setImportStatus] = useState("");
 
  const [filters, setFilters] = useState({
    name: "",
    age: "",
    contactNo: "",
    location: "",
    educationQualification: "",
    organisation: "",
    designation: "",
    email: "",
    gender: "",
    totalExperience: "",
    positionsSuitableFor: "",
    skills: "",
  });
 
  const [ageMin, setAgeMin] = useState("");
  const [ageMax, setAgeMax] = useState("");
  const [experienceMin, setExperienceMin] = useState("");
  const [experienceMax, setExperienceMax] = useState("");

  useEffect(() => {
    const storedUsedButtons = JSON.parse(localStorage.getItem("usedButtons"));
    if (storedUsedButtons) {
      setUsedButtons(new Set(storedUsedButtons));
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [filters, searchTerm, ageMin, ageMax, experienceMin, experienceMax]);

  const fetchData = async () => {
    setLoading(true);
    try {
      let response;
      if (userRole === "Admin") {
        response = await axios.get(`${baseUrl}/api/applications`);
      } else {
        response = await axios.get(`${baseUrl}/api/applications/${userId}`);
      }
      let formDataArray = response.data;
      formDataArray = formDataArray.map((form) => ({
        ...form,
        age: Number(form.age) || 0,
        // Keep totalExperience as original value for display (e.g., string like "5 years" or number)
      }));
      const filteredData = formDataArray.filter((formData) => {
       const ageInRange =
          (formData.age >= ageMin || !ageMin) && (formData.age <= ageMax || !ageMax);
        const experienceInRange =
          (formData.totalExperience >= experienceMin || !experienceMin) &&
          (formData.totalExperience <= experienceMax || !experienceMax);
        return (
          formData.name.toLowerCase().includes(filters.name.toLowerCase()) &&
          formData.contactNo.includes(filters.contactNo) &&
          formData.location.toLowerCase().includes(filters.location.toLowerCase()) &&
          formData.educationQualification
            .toLowerCase()
            .includes(filters.educationQualification.toLowerCase()) &&
          formData.organisation.toLowerCase().includes(filters.organisation.toLowerCase()) &&
          formData.designation.toLowerCase().includes(filters.designation.toLowerCase()) &&
          formData.email.toLowerCase().includes(filters.email.toLowerCase()) &&
          formData.positionsSuitableFor
            .toLowerCase()
            .includes(filters.positionsSuitableFor.toLowerCase()) &&
          formData.skills.toLowerCase().includes(filters.skills.toLowerCase()) &&
          ageInRange &&
          experienceInRange &&
          (formData.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            formData.contactNo.includes(searchTerm) ||
            formData.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
            formData.educationQualification
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            formData.organisation.toLowerCase().includes(searchTerm.toLowerCase()) ||
            formData.designation.toLowerCase().includes(searchTerm.toLowerCase()) ||
            formData.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            formData.positionsSuitableFor
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            formData.skills.toLowerCase().includes(searchTerm.toLowerCase()))
        );
      });
      setFormDataList(filteredData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (email) => {
    const confirmation = window.confirm("Are you sure you want to delete this record?");
    if (!confirmation) return;
    try {
      await axios.delete(`${baseUrl}/api/applications/${email}`);
      alert("Record deleted successfully");
      fetchData();
    } catch (error) {
      console.error("Error deleting record:", error);
      alert("Failed to delete record");
    }
  };

  const handleButtonClick = (id) => {
    if (usedButtons.has(id)) {
      navigate(`/viewanalysis/${id}`);
    } else {
      usedButtons.add(id);
      setUsedButtons(new Set(usedButtons));
      localStorage.setItem("usedButtons", JSON.stringify([...usedButtons]));
      navigate(`/addanalysis/${id}`);
    }
  };

  // Excel Import Functions
  const downloadTemplate = () => {
    const templateData = [
      {
        "Name": "John Doe",
        "Age": 30,
        "Contact No": "1234567890",
        "Location": "New York",
        "Education Qualification": "Bachelor's Degree",
        "Organisation": "ABC Corp",
        "Designation": "Software Engineer",
        "Email": "john.doe@example.com",
        "Gender": "Male",
        "Total Experience": 5,
        "Positions Suitable For": "Senior Developer, Team Lead",
        "Skills": "JavaScript, React, Node.js"
      }
    ];
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "application_template.xlsx");
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImportFile(file);
    }
  };

  const importExcelData = async () => {
    if (!importFile) {
      setImportStatus("Please select a file first.");
      return;
    }
    try {
      setImportStatus("Processing file...");
     
      const data = await readExcelFile(importFile);
      setImportStatus(`Found ${data.length} records. Importing...`);
      const results = await bulkImportApplications(data);
     
      if (results.success > 0) {
        setImportStatus(`Successfully imported ${results.success} records. ${results.duplicates} duplicates skipped.`);
        fetchData(); // Refresh the data
        setTimeout(() => {
          setShowImportModal(false);
          setImportStatus("");
          setImportFile(null);
        }, 2000);
      } else {
        setImportStatus("No records were imported. All emails already exist.");
      }
    } catch (error) {
      console.error("Import error:", error);
      setImportStatus("Error importing data: " + error.message);
    }
  };

  const readExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
     
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          resolve(jsonData);
        } catch (error) {
          reject(error);
        }
      };
     
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  const bulkImportApplications = async (applications) => {
    try {
      console.log('Sending applications to server:', applications);
     
      const response = await axios.post(`${baseUrl}/bulk-import`, {
        applications: applications,
        user_id: userId
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
     
      console.log('Server response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Import API error:', error);
      throw new Error(error.response?.data?.message || "Import failed");
    }
  };

  const clearFilters = () => {
    setFilters({
      name: "",
      contactNo: "",
      location: "",
      educationQualification: "",
      organisation: "",
      designation: "",
      email: "",
      gender: "",
      positionsSuitableFor: "",
      skills: "",
    });
    setAgeMin("");
    setAgeMax("");
    setExperienceMin("");
    setExperienceMax("");
    setActiveFilter(null);
  };

  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [activeFilter]: value,
    }));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterClick = (column) => {
    setActiveFilter(column);
  };

  const handleLogout = () => {
    logout();
    alert("You have successfully logged out");
    navigate("/");
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const reversedFilteredData = [...formDataList];

  return (
    <div className="container-fluid mt-5">
      <div className="row">
        <div className="col-md-2">
          <Navbar />
        </div>
        <div className="col-md-10">
          <div className="container mt-5">
            <h2 className="text-center mb-4">View Applications</h2>
            <div className="row mb-3">
              <div className="search-bar col-md-6">
                <input
                  type="text"
                  placeholder="Search table..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                &nbsp; &nbsp;
                <button onClick={clearFilters} className="btn btn-secondary">
                  Clear Filters
                </button>
              </div>
              {/* <div className="col-md-6 text-end">
                <button
                  className="btn btn-success"
                  onClick={() => setShowImportModal(true)}
                >
                  <FontAwesomeIcon icon={faFileExcel} /> Import Excel
                </button>
              </div> */}
            </div>
            {/* Excel Import Modal */}
            {showImportModal && (
              <div className="modal show d-block" tabIndex="-1">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Import Applications from Excel</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                          setShowImportModal(false);
                          setImportStatus("");
                          setImportFile(null);
                        }}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={downloadTemplate}
                        >
                          Download Template
                        </button>
                      </div>
                      <div className="mb-3">
                        <input
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={handleFileUpload}
                          className="form-control"
                        />
                      </div>
                      {importStatus && (
                        <div className={`alert ${importStatus.includes('Error') ? 'alert-danger' : 'alert-info'}`}>
                          {importStatus}
                        </div>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowImportModal(false);
                          setImportStatus("");
                          setImportFile(null);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={importExcelData}
                        disabled={!importFile}
                      >
                        Import Data
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div style={{ overflowX: "auto", maxHeight: "450px" }}>
              
                <table className="table table-striped table-bordered">
                  <thead className="table-primary">
                    <tr className="custom-date-column">
                      <th>S.No</th>
                      <th>
                        Name
                        {activeFilter === "name" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Name"
                              value={filters.name}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("name")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                        <th>
                        Age
                        {activeFilter === "age" ? (
                          <div className="filter-range">
                            <input
                              type="number"
                              placeholder="Min"
                              value={ageMin}
                              onChange={(e) => setAgeMin(e.target.value)}
                              className="filter-input"
                            />
                            <input
                              type="number"
                              placeholder="Max"
                              value={ageMax}
                              onChange={(e) => setAgeMax(e.target.value)}
                              className="filter-input"
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("age")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Contact No
                        {activeFilter === "contactNo" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Contact No"
                              value={filters.contactNo}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("contactNo")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Location
                        {activeFilter === "location" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Location"
                              value={filters.location}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("location")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Education Qualification
                        {activeFilter === "educationQualification" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Education Qualification"
                              value={filters.educationQualification}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span
                            onClick={() =>
                              handleFilterClick("educationQualification")
                            }
                          >
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Organisation
                        {activeFilter === "organisation" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Organisation"
                              value={filters.organisation}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("organisation")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Designation
                        {activeFilter === "designation" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Designation"
                              value={filters.designation}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("designation")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Email
                        {activeFilter === "email" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Email"
                              value={filters.email}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("email")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Gender
                        {activeFilter === "gender" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Gender"
                              value={filters.gender}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("gender")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Total Experience
                        {activeFilter === "totalExperience" ? (
                          <div className="filter-range">
                            <input
                              type="number"
                              placeholder="Min"
                              value={experienceMin}
                              onChange={(e) => setExperienceMin(e.target.value)}
                              className="filter-input"
                            />
                            <input
                              type="number"
                              placeholder="Max"
                              value={experienceMax}
                              onChange={(e) => setExperienceMax(e.target.value)}
                              className="filter-input"
                            />
                          </div>
                        ) : (
                          <span
                            onClick={() =>
                              handleFilterClick("totalExperience")
                            }
                          >
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Position Suitable For
                        {activeFilter === "positionsSuitableFor" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Position Suitable For"
                              value={filters.positionsSuitableFor}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span
                            onClick={() =>
                              handleFilterClick("positionsSuitableFor")
                            }
                          >
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>
                        Skills
                        {activeFilter === "skills" ? (
                          <div>
                            <input
                              type="text"
                              placeholder="Filter Skills"
                              value={filters.skills}
                              onChange={handleFilterChange}
                            />
                          </div>
                        ) : (
                          <span onClick={() => handleFilterClick("skills")}>
                            <FontAwesomeIcon icon={faFilter} />
                          </span>
                        )}
                      </th>
                      <th>Resume</th>
                      <th>Analysis</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {loading ? (
  <tbody>
    <tr>
      <td colSpan="18">
        <div className="d-flex flex-column justify-content-center align-items-center p-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading data...</p>
        </div>
      </td>
    </tr>
  </tbody>
) : (

                  <tbody className="custom-date-column">
                    {reversedFilteredData.map((formData, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formData.name}</td>
                        <td>{formData.age}</td>
                        <td>{formData.contactNo}</td>
                        <td>{formData.location}</td>
                        <td>{formData.educationQualification}</td>
                        <td>{formData.organisation}</td>
                        <td>{formData.designation}</td>
                        <td>{formData.email}</td>
                        <td>{formData.gender}</td>
                        <td>{formData.totalExperience}</td>
                        <td>{formData.positionsSuitableFor}</td>
                        <td>{formData.skills}</td>
                        <td>
                          <a
                            href={`${baseUrl}${formData.resumeUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        </td>
                        <td>
                          <button
                            onClick={() => handleButtonClick(formData.id)}
                            disabled={usedButtons.has(formData.id)}
                          >
                            {usedButtons.has(formData.id) ? (
                              <Link to={`/viewanalysis/${formData.id}`}>
                                View
                              </Link>
                            ) : (
                              "Add"
                            )}
                          </button>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            icon={faTrash}
                            onClick={() => handleDelete(formData.email)}
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                    )}
                </table>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewApplication;